export default "__VITE_ASSET__D9$yzu8O__"